import { z } from 'zod'
import { api } from '@/shared/api/client'
import { uuidSchema } from '@/shared/api/schemas'

export const LOGO_ACCEPT = 'image/png,image/jpeg,image/webp'

/** A4 hisob-fakturada 60 mm enida 250 dpi atrofida */
export const MIN_LOGO_WIDTH_PX = 600

/** `TenantBrandingUpdate` bilan bir xil chegaralar */
export const BRANDING_RULES = {
  companyNameMax: 120,
  addressMax: 240,
  emailMax: 190,
  websiteMax: 200,
  cardInstructionsMax: 160,
  email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  website: /^(https?:\/\/)?([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}(:[0-9]{1,5})?(\/[^\s<>"'\\]*)?$/i,
} as const

const brandingSchema = z.object({
  companyName: z.string().nullish(),
  address: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  website: z.string().nullish(),
  logoUrl: z.string().nullish(),
  logoFileId: uuidSchema.nullish(),
  cardInstructions: z.string().nullish(),
})

export interface CompanyDetails {
  companyName: string | null
  address: string | null
  /** E.164 */
  phone: string | null
  email: string | null
  website: string | null
  cardInstructions: string | null
}

export interface TenantBranding extends CompanyDetails {
  /** Ochiq havola; `null` — logotip yuklanmagan */
  logoUrl: string | null
}

function toBranding(raw: unknown): TenantBranding {
  const parsed = brandingSchema.parse(raw)
  return {
    companyName: parsed.companyName ?? null,
    address: parsed.address ?? null,
    phone: parsed.phone ?? null,
    email: parsed.email ?? null,
    website: parsed.website ?? null,
    cardInstructions: parsed.cardInstructions ?? null,
    logoUrl: parsed.logoUrl ?? null,
  }
}

export async function fetchBranding(): Promise<TenantBranding> {
  const response = await api.get<unknown>('/api/tenant-settings/branding')
  return toBranding(response.data)
}

export async function saveCompanyDetails(details: CompanyDetails): Promise<TenantBranding> {
  const response = await api.put<unknown>('/api/tenant-settings/branding', details)
  return toBranding(response.data)
}

export async function uploadLogo(file: File): Promise<TenantBranding> {
  const form = new FormData()
  form.append('file', file)
  const response = await api.post<unknown>('/api/tenant-settings/branding/logo', form, {
    headers: { 'Content-Type': undefined },
  })
  return toBranding(response.data)
}

export async function removeLogo(): Promise<TenantBranding> {
  const response = await api.delete<unknown>('/api/tenant-settings/branding/logo')
  return toBranding(response.data)
}
